/**
 * Created by jerry on 2017/4/14.
 */
var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'

import Vue from 'vue'
import auth from "./auth.js"
import configs from "../configs/configs.js";
import request from "../models/request.js";
import { getLocalStorage } from "@/common/auth";

Vue.prototype.highPrecisionAdd = function(data1, data2) { // 加法
    let r1, r2, m;
    // 获取每个参数的小数的位数
    try { r1 = data1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = data2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    // 计算底数为10以最大小数位数为次幂的值
    m = Math.pow(10, Math.max(r1, r2));
    // 把所有参数转为整数后相加再除以次幂的值
    return (data1 * m + data2 * m) / m;
};

Vue.prototype.highPrecisionReduce = function(data1, data2) { // 减法
    let r1, r2, m, n;
    // 获取每个参数的小数的位数
    try { r1 = data1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = data2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    // 计算底数为10以最大小数位数为次幂的值
    m = Math.pow(10, Math.max(r1, r2));
    //精度长度以最大小数位数为长度
    n = (r1 >= r2) ? r1 : r2;
    return ((data1 * m - data2 * m) / m).toFixed(n);
};

Vue.prototype.highPrecisionMul = function(data1, data2) { // 乘法
    let m = 0,
        s1 = data1.toString(),
        s2 = data2.toString();
    // 获取所有参数小数位长度之和
    try { m += s1.split(".")[1].length } catch (e) {}
    try { m += s2.split(".")[1].length } catch (e) {}
    // 替换掉小数点转为数字相乘再除以10的次幂值
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};

Vue.prototype.highPrecisionDiv = function(data1, data2) { // 除法
    let t1 = 0,
        t2 = 0,
        r1, r2;
    // 获取每个参数的小数的位数
    try { t1 = data1.toString().split(".")[1].length } catch (e) {}
    try { t2 = data2.toString().split(".")[1].length } catch (e) {}
    // 把所有参数的小数点去掉转为整数
    r1 = Number(data1.toString().replace(".", ""));
    r2 = Number(data2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
};

export default {
    // 深拷贝
    deepCopy(params) {
        return JSON.parse(JSON.stringify(params));
    },
    // 参数格式化
    paramsFormat(params) {
        for (let i in params) {
            if (params[i] === '' || params[i] === undefined) {
                delete params[i]
            }
        }

        return params
    },
    // 替换所有字段
    replaceAll(str, before, after) {
        return str.replace(RegExp(before, "g"), after);
    },
    /**
     * 校验手机号
     * @param  {string} mobile 手机号
     * @return {object}        校验结果对象，包括：isValid（boolean）是否有效、message（string）提示语
     */
    validateMobile(mobile) {
        var result = {};
        result.isValid = true;

        if (!mobile) {
            result.isValid = false;
            result.message = '请输入手机号码！';
            return result;
        }
        if (mobile.length !== 11) {
            result.isValid = false;
            result.message = '请输入有效的手机号码！';
            return result;
        }

        var myreg = /^1[34578]\d{9}$/;
        if (!myreg.test(mobile)) {
            result.isValid = false;
            result.message = '请输入有效的手机号码！';
            return result;
        }

        return result;
    },
    /* 
    * 根据地区号校验手机号
    */
    validateMobileWithAreaCode(areaCode, mobile, isCheckareaCode) {
        var result = {};
        result.isValid = true;

        if (!mobile) {
            if(!isCheckareaCode) {
                result.isValid = false;
                result.message = '请输入手机号码';
                return result;
            }
            
        }

        var myreg = '';
        switch (areaCode) {
            case '86':
                myreg = /^[1][3-9]\d{9}$/
                break;
            case '852':
                myreg = /^([6|9])\d{7}$/
                break;
            case '853':
                myreg = /^[6]([8|6])\d{5}$/
                break;
            case '886':
                myreg = /^[0][9]\d{8}$/
                break;
            case '1':
                myreg = /^[2-9]\d{2}[2-9](?!11)\d{6}$/
                break;
        }
        if (!myreg.test(mobile)) {
            result.isValid = false;
            result.message = '请输入有效的手机号码';
            return result;
        }

        return result;
    },
    /* 
    * 验证变量是否为空
    */
    isEmpty(val) {
        var result = {};
        result.isValid = true;
        
        if(val == "") {
            result.isValid = false;
            result.message = "请填写必填项";
            return result;
        }
        return result;
    },
    /**
     * 校验邮箱
     * @param  {string} email  邮箱
     * @return {object}        校验结果对象，包括：isValid（boolean）是否有效、message（string）提示语
     */
    validateEmail(email) {
        var result = {};
        result.isValid = true;

        if (!email) {
            result.isValid = false;
            result.message = "请输入电子邮箱";
            return result;
        }

        var myreg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (!myreg.test(email)) {
            result.isValid = false;
            result.message = "请输入有效的电子邮箱";
            return result;
        }

        return result;
    },
    // 各个地区手机号码验证
    phoneCheck(form) {
        let result = false

        switch (form.area_code) {
            case '86':
                result = /^[1][3-9]\d{9}$/.test(form.phone)
                break
            case '852':
                result = /^([6|9])\d{7}$/.test(form.phone)
                break
            case '853':
                result = /^[6]([8|6])\d{5}$/.test(form.phone)
                break
            case '886':
                result = /^[0][9]\d{8}$/.test(form.phone)
                break
            case '1':
                result = /^[2-9]\d{2}[2-9](?!11)\d{6}$/.test(form.phone)
                break
        }

        return result
    },
    // 映射服务类型
    mapServiceTypes(codeArray) {
        let arr = JSON.parse(getLocalStorage('tags')).serve_type,
            obj = {},
            valArray = []

        arr.forEach(ele => {
            obj[ele.code] = ele
        });

        for (let index = 0; index < codeArray.length; index++) {
            const element = codeArray[index];
            
            valArray.push(obj[element].name)
        }

        return valArray.join('、')
    },
    isWeixin() {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },

    isAlipay() {
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/Alipay/i) == "alipay") {
            return true;
        } else {
            return false;
        }
    },
    getQueryStringByName: function(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = window.location.search.substr(1).match(reg)
        var context = ''
        if (r != null) {
            context = r[2]
        }
        reg = null
        r = null
        return context === null || context === '' || context === 'undefined' ? '' : context
    },
    getQueryString: function(name) {
        return (
            decodeURIComponent(
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
                    ,
                    ''
                ])[1].replace(/\+/g, '%20')
            ) || null
        )
    },
    /**
     * 拼接URL
     * @param {*} url
     * @param {*} params
     */
    spliceUrl: function(url, params) {
        const arr = []
        if (params) {
            Object.keys(params).forEach(item => {
                arr.push(item + '=' + params[item])
            })
            if (url.search(/\?/) === -1) {
                url += '?' + arr.join('&')
            } else {
                url += '&' + arr.join('&')
            }
        }
        return url
    },
    formatDate: {
        format: function(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN
            return pattern.replace(SIGN_REGEXP, function($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length)
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length)
                    case 'd':
                        return padding(date.getDate(), $0.length)
                    case 'w':
                        return date.getDay() + 1
                    case 'h':
                        return padding(date.getHours(), $0.length)
                    case 'm':
                        return padding(date.getMinutes(), $0.length)
                    case 's':
                        return padding(date.getSeconds(), $0.length)
                }
            })
        },
        parse: function(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP)
            var matchs2 = dateString.match(/(\d)+/g)
            if (matchs1.length === matchs2.length) {
                var _date = new Date(1970, 0, 1)
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i])
                    var sign = matchs1[i]
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int)
                            break
                        case 'M':
                            _date.setMonth(_int - 1)
                            break
                        case 'd':
                            _date.setDate(_int)
                            break
                        case 'h':
                            _date.setHours(_int)
                            break
                        case 'm':
                            _date.setMinutes(_int)
                            break
                        case 's':
                            _date.setSeconds(_int)
                            break
                    }
                }
                return _date
            }
            return null
        }
    },
    setTitle: function(t) {
        document.title = t
        var i = document.createElement('iframe')
        i.src = '//m.baidu.com/favicon.ico'
        i.style.display = 'none'
        i.onload = function() {
            setTimeout(function() {
                i.remove()
            }, 9)
        }
        document.body.appendChild(i)
    }
}



// WEBPACK FOOTER //
// ./src/common/util.js